export default __webpack_public_path__ + "static/media/bedding_light.756d245c.png";